import { LocalizationState } from "../context/Localization/LocalizationProvider"

export const english: LocalizationState = {
    locale: 'en-us',
    translations: {
        CriteriaEngine: 'Criteria Engine',
        AddGroupCondition: 'Add New Condition Group',
        DeleteGroupCondition: 'Delete Condition Group',
        SetupConditions: 'Setup Conditions',
        ConfigureConditionsDesc: 'Configure the conditions that will populate the Offer Form with the list of the available Form(s)'
    },
    timezone: 'PST',
} as any